import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Subject} from 'rxjs';
import {map} from 'rxjs/operators';

import {UnitCardService} from 'src/app/services/shared/unit-card.service';
import {UnitCardsSliderComponent} from '../unit-cards-slider/unit-cards-slider.component';

@Component({
    selector: 'terra-unit-cards-section',
    templateUrl: './unit-cards-section.component.html',
    styleUrls: ['./unit-cards-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitCardsSectionComponent extends OnDestroyMixin implements OnInit {
    @ViewChild(UnitCardsSliderComponent) cardSlider: UnitCardsSliderComponent;
    @Input() refreshCards$ = new Subject<boolean>();

    businessVirtualDebitCards$ = this.unitCardService.unitBusinessCards$;
    viewSensitiveData$ = this.unitCardService.viewSensitiveData$;
    showEmptyCard = true;

    constructor(
        private unitCardService: UnitCardService
    ) {
        super();
    }

    ngOnInit(): void {
        this.refreshCards$.pipe(
            untilComponentDestroyed(this)
        ).subscribe(_ => {
            this.unitCardService.refreshUnitBusinessCards();
            this.showEmptyCard = false;
        });
    }

    onIndexCardChanged(index: number) {
        console.log(index);
    }
}
